// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    revisionNumber: z.number(),
    name: z.string().min(1).max(128),
    description: z.string().nullable().optional(),
    email: z.string().min(1).max(256),
    customData: jsonObjectGuard.optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    revisionNumber: z.number(),
    name: z.string().min(1).max(128),
    description: z.string().nullable(),
    email: z.string().min(1).max(256),
    customData: jsonObjectGuard,
    createdAt: z.number(),
});
export const AgentIdentityRevisions = Object.freeze({
    table: 'agent_identity_revisions',
    tableSingular: 'agent_identity_revision',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        agentId: 'agent_id',
        revisionNumber: 'revision_number',
        name: 'name',
        description: 'description',
        email: 'email',
        customData: 'custom_data',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'agentId',
        'revisionNumber',
        'name',
        'description',
        'email',
        'customData',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
